//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from '@/request/index'
import {getUrlparams, toCopy} from '@/utils/util.js'
import homeTip from '@/components/homeTip'
import bottom from '@/assets/img/bottom.png'
import {Dialog, Toast} from 'vant';

export default {
  name: "qualityProcess",
  components: {
    homeTip
  },
  data() {
    return {
      dataList:[],
      show:false,
      bottom,
      checkAll: false,
      isSend: false,
      loading: false,
      showPicker: false,
      showPicker1: false,
      showPicker2: false,
      showPicker3: false,
      showPicker4: false,
      createMessage:{stockInSn:'',redoneOrderSn:'',returnOrderSn:'',qualityOrderSn:'',sendOrderSn:''},
      dialogFormVisible: false,
      isAllQualityStr: '否',
      isFullQualityStr: '全部全检',
      isStockInStr: '是',
      isRedoneStr: '否',
      redoneTypeStr: '',
      toCopy,
      reasonShow: false,
      columns: [{text: '是', value: 1}, {text: '否', value: 0}],
      columns1: [{text: '全部全检', value: 1}, {text: '部分全检', value: 0}],
      columns2: [{text: '现场返工', value: 1}, {text: '退回返工', value: 2}],
      popReason: '',
      list: [],
      reasonList: [
      ],
      auditForm: {
        isAllQuality: 0,
        isFullQuality: 1,
        isStockIn: 1,
        isRedone: 0,
        redoneType: null,
      },
      basicForm: {
        spuCode: '',
        isAllQuality: 0,
        isFullQuality: 1,
        isStockIn: 1,
        isRedone: 0,
        redoneType: null,
        purchaseRemark: '',
        qualityOrderSn: '',
        sendOrderSn: '',
        purchaseOrderSn: '',
        supplierName: '',
        channelStr: '',
        qualityOrderTypeName: '',
        qualityOrderDetailList: [],
        qualityOrderResultDetailList: [],
        isStockIn: '',
        confirmFileStr: '',
        confirmFile: '',
        remark: '',
        qualityResult: '',
        qualityOrderStatusName: '',
        billDate: '',
        attachedFile: [],
        spotCheckTotalNum: '',
        goodTotalNum: '',
        normalTotalNum: '',
        badTotalNum: '',
        sendTotalGoodsNum: 0,
        rejectNum: '',
        colorList: [],
        colorResultList: [],
        deliveryName: '',
        realitySupplierName: '',
        qualityType: '',
      },
      dataList: {},
      aduitParams: {},
      qualityOrderId: '',
      qualityResultId: '',
      purchaseOrderId: '',
      spuCode: '',
    }
  },
  created() {
  },
  mounted() {
    if (this.$route.query.purchaseOrderId) {
      this.purchaseOrderId = this.$route.query.purchaseOrderId
      this.spuCode = this.$route.query.spuCode
    }
    this.getSpecList()
  },
  methods: {
    getSpecList() {
      var queryParams = {
        purchaseOrderId: this.purchaseOrderId,
        spuCode: this.spuCode
      };
      axiosApi.orderProgress(queryParams).then(response => {
        this.dataList = response.content;
      }).catch(error => {
        // this.$refs.commonTableRef2.reloadDone()
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/purchase/qualityProcess.vue